import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import NhisRequestAuthRq from '@domain/rq/nhis/NhisRequestAuthRq';
import NhisCompanyReportListGetRs from '@domain/rs/nhis/NhisCompanyReportListGetRs';

export default interface NHISRepo {
  // NHIS 인증 확인
  fetchNHISAuthCheck(): Promise<AxiosResponse>;

  // NHIS 인증 요청
  fetchNHISAuthRequest(rq: NhisRequestAuthRq): Promise<AxiosResponse>;

  // NHIS 경력 및 급여 조회
  fetchNHISCompaniesReport(): Promise<AxiosResponse<NhisCompanyReportListGetRs>>;
}

export class RemoteNHISRepo implements NHISRepo {
  fetchNHISAuthCheck(): Promise<AxiosResponse> {
    return axios.post(`/nhis/auth/check`);
  }

  fetchNHISAuthRequest(rq: NhisRequestAuthRq): Promise<AxiosResponse> {
    return axios.post(`/nhis/auth/request`, rq);
  }

  fetchNHISCompaniesReport(): Promise<AxiosResponse<NhisCompanyReportListGetRs>> {
    return axios.get(`/nhis/companies/report`);
  }
}
